import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { Box, TableCell, Typography } from '@mui/material';
import Logger from '../../lib/Logger';
import { renderErrorMessage, renderSuccessMessage } from '../../lib/toastMessage';
import { LoadingButton } from '@mui/lab';

// import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';

// import { CustomMenu } from 'src/components/menu/customMenu';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
// import { axiosVBGetCall } from '../../../services/vbApiCall';
import { PaginationTable } from './paginationTable';
import { axiosGetCall } from 'src/services/apisCall';

const BasicDatePicker = ({ value, onChange }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        slotProps={{
          textField: { size: 'small' },
          actionBar: {
            actions: ['today', 'clear'],
          },
        }}
        sx={{ width: '270px', margin: '8px' }}
        value={value}
        onChange={(newValue) => onChange(newValue)}
      />
    </LocalizationProvider>
  );
};

BasicDatePicker.propTypes = {
  value: propTypes.number,
  onChange: propTypes.func.isRequired,
};

export const ResellerPlanTable = ({ credits = [], assignedPlan = [], user = {}, forceLoad, loading: tableLoading }) => {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const logger = new Logger('senderId');
  const handleFieldChange = (rowIndex, key, value) => {
    setRows((prevRows) => {
      const newRows = [...prevRows];
      newRows[rowIndex] = { ...newRows[rowIndex], [key]: value };
      return newRows;
    });
  };
  const handleAssignPlan = async (plan, setLoading) => {
    setLoading(true);
    try {
      const { plan_id, type, market, auth, utility, open,credit_per_template, template_type } = plan;
      const { userId } = user;
      let message;
      if (type === 'A') {
        const payload = { planId: plan_id, assignTo: userId, market, auth, utility, open};
        message = await axiosGetCall('assignWhatsAppAmountPlans', payload);
      } else {
        const payload = {
          planId: plan_id,
          assignTo: userId,
          creditPerTemplate: credit_per_template,
          templateType: template_type,
        };
        message = await axiosGetCall('assignWhatsAppCreditPlans', payload);
      }
      forceLoad();
      renderSuccessMessage(message);
    } catch (error) {
      logger.error('DeliveryLogsTable.jsx ,getDeliveryLogs ,deliveryLogs api', error);
      renderErrorMessage(error?.message);
    }
    setLoading(false);
  };

  const checkPlanAssignStatus = (planId) => {
    let count = false;
    assignedPlan.map(({ plan_id }) => {
      if (plan_id === planId) count = true;
      return null;
    });
    return count;
  };

  useEffect(() => {
    setRows(credits);
  }, [credits]);

  const columns = [
    { id: 'plan_id', label: 'Plan ID', minWidth: 70, align: 'center' },
    {
      id: 'country_code',
      label: 'Country Code',
      minWidth: 70,
      align: 'center',
    },
    { id: 'market', label: 'Market ', minWidth: 70, align: 'center' },
    { id: 'auth', label: 'Auth', minWidth: 70, align: 'center' },
    { id: 'utility', label: 'Utility ', minWidth: 70, align: 'center' },
    { id: 'open', label: 'Open', minWidth: 70, align: 'center' },
    { id: 'credit_per_template', label: 'Credit Per Template ', minWidth: 70, align: 'center' },

    { id: 'template_type', label: 'Template Type', minWidth: 70, align: 'center' },
    { id: 'type', label: 'Type', minWidth: 70, align: 'center' },

    {
      id: 'create_date',
      label: 'create_date',
      minWidth: 70,
      align: 'center',
    },

    {
      id: 'actions',
      label: 'Action',
      minWidth: 80,
      align: 'center',
    },
  ];

  const ActionJsx = ({ id, align, value, row }) => {
    const [assignPlanLoading, setAssignPlanLoading] = useState();
    const planId = typeof row?.plan_id === 'string' ? row.plan_id : String(row?.plan_id);

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.400',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.700',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <LoadingButton
            disabled={checkPlanAssignStatus(planId)}
            onClick={() => handleAssignPlan(row, setAssignPlanLoading)}
            loading={assignPlanLoading}
            variant="outlined"
            size="small"
            color="primary"
          >
            Assign
          </LoadingButton>
        </Box>
      </TableCell>
    );
  };

  return (
    <Box>
      <Typography
        id="modal-modal-title"
        variant="h6"
        component="h2"
        sx={{ mb: '-20px' }}
        // sx={{ color: 'grey.10' }}
      >
        Reseller login Plans
      </Typography>
      <PaginationTable
        page={page}
        ActionJsx={ActionJsx}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        loading={tableLoading}
        rows={rows}
        columns={columns}
        maxHeight={680}
        mapKey="planName"
        onRowFieldChange={handleFieldChange}
      />
    </Box>
  );
};